import { useEffect } from 'react';

import { IS_PRODUCTION_BUILD } from '@/shared/environments';

import { useHubSpotChatStore } from './useHubSpotChatStore';

type UseInitHubSpotChatArgs = {
  defaultSpaceId?: string;
};

const setHubSpotPath = (path: string) => {
  if (!window._hsq) return;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  window._hsq.push(['setPath', path], ['trackPageView']);
};

export const useInitHubSpotChat = ({ defaultSpaceId }: UseInitHubSpotChatArgs = {}) => {
  const onWidgetReady = useHubSpotChatStore((state) => state.onWidgetReady);
  const onUnreadConversationCountChanged = useHubSpotChatStore((state) => state.onUnreadConversationCountChanged);

  useEffect(() => {
    if (!IS_PRODUCTION_BUILD) {
      return;
    }

    const pinnedPath = defaultSpaceId ? `/spaces/${defaultSpaceId}` : null;

    const initHubSpot = () => {
      if (window.HubSpotConversations) {
        if (pinnedPath) {
          setHubSpotPath(pinnedPath);
        }

        window.HubSpotConversations.widget.load({ widgetOpen: false });
        window.HubSpotConversations.on('widgetLoaded', onWidgetReady);
        window.HubSpotConversations.on('unreadConversationCountChanged', onUnreadConversationCountChanged);
      }
    };

    if (window.HubSpotConversations) {
      initHubSpot();
    } else {
      window.hsConversationsOnReady = [...(window.hsConversationsOnReady || []), initHubSpot];
    }

    return () => {
      if (window.HubSpotConversations) {
        window.HubSpotConversations.off('widgetLoaded', onWidgetReady);
        window.HubSpotConversations.off('unreadConversationCountChanged', onUnreadConversationCountChanged);
      }
    };
  }, [defaultSpaceId, onUnreadConversationCountChanged, onWidgetReady]);

  useEffect(() => {
    if (!IS_PRODUCTION_BUILD || !defaultSpaceId) return;

    setHubSpotPath(`/spaces/${defaultSpaceId}`);
    window.HubSpotConversations?.widget.refresh({ openToNewThread: false });
  }, [defaultSpaceId]);
};
